import useIsMobile from '@/hooks/useIsMobile'
import React from 'react'

const CategorySkeleton = ({
  active = false
}: CategorySkeletonProps): JSX.Element => {
  return (
    <div
      className={`flex items-center gap-5 rounded-[18px] px-4 py-4 animate-pulse ${
        active ? 'bg-gray-100' : ''
      }`}
    >
      {/* Icon */}
      <div className="h-[84px] w-[84px] shrink-0 rounded-[18px] bg-gray-200" />

      {/* Category Name */}
      <div className="flex-1">
        <div className="h-6 w-36 rounded bg-gray-200" />

        {active && (
          <div className="mt-2 h-6 w-24 rounded bg-gray-200" />
        )}
      </div>
    </div>
  )
}

const LocalityCardSkeleton = (): JSX.Element => {
  return (
    <div className="h-[125px] w-full rounded-[20px] border border-[#E1E1E1] bg-white px-7 py-6 animate-pulse">
      {/* Locality Name */}
      <div className="h-7 w-36 rounded bg-gray-200" />

      {/* Store Count */}
      <div className="mt-4 h-5 w-48 rounded bg-gray-200" />
    </div>
  )
}

const CityPageSkelton = (): JSX.Element => {
  const isMobile = useIsMobile()
  return (
    <div className={`container ${isMobile ? '' : 'mx-auto'}`}>
      <div className="pt-4">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 mb-8 animate-pulse">
          <div className="h-5 w-16 rounded bg-gray-200" />
          <div className="h-4 w-2 rounded bg-gray-200" />
          <div className="h-5 w-20 rounded bg-gray-200" />
        </div>

        {/* Page Title */}
        <div className="animate-pulse">
          <div className="h-[48px] w-[600px] max-w-full rounded bg-gray-200" />

          {/* Description */}
          <div className="mt-5 h-6 w-[650px] max-w-full rounded bg-gray-200" />
        </div>

        {/* Main Content */}
        <div
          className={`mt-12 flex ${
            isMobile ? 'flex-col' : 'gap-14'
          }`}
        >
          {/* Shop Categories */}
          <div
            className={`${
              isMobile ? 'w-full' : 'w-[394px] shrink-0'
            }`}
          >
            <div className="rounded-[20px] border border-[#E1E1E1] bg-white px-6 py-7 animate-pulse">
              {/* Title */}
              <div className="h-7 w-44 rounded bg-gray-200" />

              {/* Category Items */}
              <div className="mt-7 space-y-5">
                <CategorySkeleton active />
                <CategorySkeleton />
                <CategorySkeleton />
                <CategorySkeleton />
              </div>
            </div>
          </div>

          {/* Localities */}
          <div className="min-w-0 flex-1">
            {/* Header */}
            <div className="flex items-center justify-between animate-pulse">
              <div className="h-8 w-72 rounded bg-gray-200" />

              <div className="h-5 w-32 rounded bg-gray-200" />
            </div>

            {/* Locality Cards */}
            <div
              className={`mt-7 grid gap-5 ${
                isMobile ? 'grid-cols-1' : 'grid-cols-2'
              }`}
            >
              {Array.from({ length: 9 }).map((_, index) => (
                <LocalityCardSkeleton key={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

interface CategorySkeletonProps {
  active?: boolean
}

export default CityPageSkelton
